import styled from 'styled-components';
import { Title2SemiBold } from 'styles/Global/typography';
type SectionProps = {
    title: string;
    backgroundColor?: string;
    padding?: string;
    children: React.ReactNode;
};

export default function SectionCard({ title, backgroundColor, padding, children }: SectionProps) {
    return (
        <SectionContainer $backgroundColor={backgroundColor} $padding={padding}>
            <SectionTitleContainer>
                <Title2SemiBold>{title}</Title2SemiBold>
            </SectionTitleContainer>
            {children}
        </SectionContainer>
    );
}

const SectionContainer = styled.div<{ $gap?: string; $padding?: string; $backgroundColor?: string }>`
    display: flex;
    flex-direction: column;
    padding: ${(props) => props.$padding ?? '48px 0px'};
    background-color: ${(props) => props.$backgroundColor ?? 'transparent'};
`;

const SectionTitleContainer = styled.div`
    display: flex;
    gap: 12px;
    padding: 0px 16px;
    padding-bottom: 24px;
`;
